export const data = {
    name: "Rigs",
    layout: [],
};
export default data;